import { Route, Routes, useNavigate } from 'react-router-dom'

import PageLoader from 'Components/PageLoader'

import { useGetAppQuery } from './jira.service'

import InstallJira from './InstallJira'
import ManageJira from './ManageJira'
import JiraAuthForm from './JiraAuthForm'

const Jira = () => {
  const { isLoading, data: app = {} } = useGetAppQuery()
  const navigate = useNavigate()

  if (isLoading) {
    return <PageLoader />
  }

  if (!app.is_linked) {
    return <InstallJira app={app} />
  }

  const handleAuthFormCancel = () => {
    navigate('./')
  }

  return (
    <Routes>
      <Route
        path='auth'
        element={<JiraAuthForm onCancel={handleAuthFormCancel} onAuth={handleAuthFormCancel} app={app} />}
      />
      <Route path='*' element={<ManageJira app={app} />} />
    </Routes>
  )
}

export default Jira
